// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"11f2ec57","488":"e3d9e151","732":"71bbc46b","977":"b4d9fdb2"}[chunkId] + ".chunk.js";
};